var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { t, T } from '../../../helpers/i18n';
import { Col, Container, FormGroup, Input, Label, Row } from 'reactstrap';
import InputImage from '../../../elements/FieldImage';
import { inject } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import { ButtonsBar, StyledButton } from '../../../Styles';
import { prepareToSubmitForm } from '../../../helpers/prepareToSubmitForm';
import { getChangedValues } from '../../../helpers/getChangedValues';
var ModuleMarketing = /** @class */ (function (_super) {
    __extends(ModuleMarketing, _super);
    function ModuleMarketing(props) {
        var _this = this;
        var _a;
        _this = _super.call(this, props) || this;
        _this.handleChange = function (e) {
            var _a = e.target, name = _a.name, value = _a.value;
            // @ts-ignore
            var temp = __assign({}, _this.state);
            temp.formData[name] = value;
            _this.setState(temp);
            if (_this.props.onChange) {
                _this.props.onChange(name, value, null);
            }
        };
        _this.handleSubmit = function () {
            var toUpload = getChangedValues(_this.props.marketing || {}, _this.state.formData);
            var data = prepareToSubmitForm(toUpload);
            console.log('toUpload: ', toUpload);
            console.log('data: ', data);
            if (Object.entries(toUpload).length === 0) {
                return _this.props.store.UI.newWarning(T('nothingModified'));
            }
            if (_this.props.onSubmit) {
                _this.props.onSubmit(data);
                return;
            }
            if (_this.state.formData.id) {
                _this.setState({ loading: true });
                _this.props.store.marketingStore.update(_this.state.formData.id, data, true).then(function (value) {
                    console.log('updated - value: ', value);
                    _this.setState({ loading: false });
                    _this.props.reload();
                })
                    .catch(function (error) {
                    _this.setState({ loading: false });
                });
                return;
            }
            _this.setState({ loading: true });
            _this.props.store.marketingStore.create(data, true).then(function (value) {
                console.log('value: ', value);
                _this.props.store.UI.newWarning(T('saved'));
                _this.setState({ loading: false });
            })
                .catch(function (error) {
                _this.setState({ loading: false });
            });
        };
        _this.state = { formData: __assign({}, (_a = _this.props.marketing) !== null && _a !== void 0 ? _a : {}), loading: false };
        return _this;
    }
    ModuleMarketing.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var formData = this.state.formData;
        return (React.createElement(Container, null,
            React.createElement("h4", null, T('title')),
            React.createElement(Row, null,
                React.createElement(Col, { md: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { for: "title" }, 'title'),
                        React.createElement(Input, { type: "text", name: 'title', id: 'title', value: ((_a = this.state.formData) === null || _a === void 0 ? void 0 : _a.title) || '', onChange: this.handleChange }))),
                React.createElement(Col, { md: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { for: "titleOG" }, "Title OG"),
                        React.createElement(Input, { type: "text", name: "titleOG", id: "titleOG", value: ((_b = this.state.formData) === null || _b === void 0 ? void 0 : _b.titleOG) || '', onChange: this.handleChange })))),
            React.createElement(PairedRows, { rowTitle: T('description'), fields: [
                    { name: 'description', labelName: T('description'), value: ((_c = this.state.formData) === null || _c === void 0 ? void 0 : _c.description) || '' },
                    { name: 'descriptionOG', labelName: T('descriptionOG'), value: ((_d = this.state.formData) === null || _d === void 0 ? void 0 : _d.descriptionOG) || '' },
                ], onChange: this.handleChange }),
            React.createElement(PairedRows, { rowTitle: T('locale'), fields: [
                    { name: 'locale', labelName: T('locale'), value: ((_e = this.state.formData) === null || _e === void 0 ? void 0 : _e.locale) || '' },
                    { name: 'localeOG', labelName: T('localeOG'), value: ((_f = this.state.formData) === null || _f === void 0 ? void 0 : _f.localeOG) || '' },
                ], onChange: this.handleChange }),
            React.createElement(PairedRows, { fields: [
                    { name: 'urlPageOG', labelName: T('urlPageOG'), value: ((_g = this.state.formData) === null || _g === void 0 ? void 0 : _g.urlPageOG) || '' },
                    { name: 'siteNameOG', labelName: T('siteNameOG'), value: ((_h = this.state.formData) === null || _h === void 0 ? void 0 : _h.siteNameOG) || '' },
                ], onChange: this.handleChange }),
            React.createElement("h4", null, T('images')),
            React.createElement(Row, null,
                React.createElement(Col, { md: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { for: "favicon" }, "Favicon Image"),
                        React.createElement(InputImage, { name: 'favicon', value: ((_j = this.state.formData) === null || _j === void 0 ? void 0 : _j.favicon) || '', footer: '_', onChange: function (name, value, column) {
                                var e = { target: {} };
                                e.target.name = name;
                                e.target.value = value instanceof FileList ? value[0] : value;
                                _this.handleChange(e);
                            } }))),
                React.createElement(Col, { md: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { for: "logo" }, "Logo Image"),
                        React.createElement(InputImage, { name: 'logo', value: ((_k = this.state.formData) === null || _k === void 0 ? void 0 : _k.logo) || '', footer: '_', onChange: function (name, value, column) {
                                console.log('Array.isArray(value): ', Array.isArray(value));
                                var e = { target: {} };
                                e.target.name = name;
                                e.target.value = value instanceof FileList ? value[0] : value;
                                _this.handleChange(e);
                            } })))),
            React.createElement(Row, null,
                React.createElement(Col, { md: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { for: "image" }, "Image"),
                        React.createElement(InputImage, { name: 'image', value: ((_l = this.state.formData) === null || _l === void 0 ? void 0 : _l.image) || '', footer: '_', onChange: function (name, value, column) {
                                var e = { target: {} };
                                e.target.name = name;
                                e.target.value = value instanceof FileList ? value[0] : value;
                                _this.handleChange(e);
                            } }))),
                React.createElement(Col, { md: 6 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { for: "imageOG" }, "Image OG"),
                        React.createElement(InputImage, { name: 'imageOG', value: ((_m = this.state.formData) === null || _m === void 0 ? void 0 : _m.imageOG) || '', footer: '_', onChange: function (name, value, column) {
                                var e = { target: {} };
                                e.target.name = name;
                                e.target.value = value instanceof FileList ? value[0] : value;
                                _this.handleChange(e);
                            } })))),
            React.createElement(ButtonsBar, null,
                React.createElement(StyledButton, { primary: true, loading: this.state.loading, onClick: this.handleSubmit }, t('save')))));
    };
    ModuleMarketing = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.store.marketingStore.read(null, true).then(function (marketing) { return ({ marketing: marketing }); })
        ]; })
    ], ModuleMarketing);
    return ModuleMarketing;
}(Component));
export default ModuleMarketing;
var PairedRows = function (_a) {
    var rowTitle = _a.rowTitle, fields = _a.fields, _b = _a.allWidth, allWidth = _b === void 0 ? false : _b, onChange = _a.onChange;
    var left = fields[0];
    var right = fields[1];
    return (React.createElement(React.Fragment, null,
        rowTitle && React.createElement("h4", null, rowTitle),
        React.createElement(Row, null,
            React.createElement(InputCol, { name: left.name, label: left.labelName, value: left.value, allWidth: allWidth, onChange: onChange }),
            right && React.createElement(InputCol, { name: right.name, label: right.labelName, value: right.value, allWidth: allWidth, onChange: onChange }))));
};
var InputCol = function (_a) {
    var name = _a.name, label = _a.label, value = _a.value, allWidth = _a.allWidth, onChange = _a.onChange;
    return (React.createElement(Col, { md: allWidth ? 12 : 6 },
        React.createElement(FormGroup, null,
            React.createElement(Label, { for: name }, label),
            React.createElement(Input, { type: "text", name: name, id: name, value: value, onChange: onChange }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Acount/container/ModuleMarketing.tsx
// module id = 1569
// module chunks = 0